// extracted by mini-css-extract-plugin
export default {"dayLabel":"sZv6sJtCrlHi5rhQNwU6"};